<template>
    <div class="p-3">
        <h3>RL 3.5 Rekapitulasi Kunjungan</h3>
        <hr>
        <DataTable table-id="table-pasien" title="Rekapitulasi Kunjungan" :filter-configs="filterConfigs"
            :table-options="tableOptions" :show-filter="true" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
                {
                    id: 'start_date',
                    label: 'Tanggal Awal',
                    field: 'start_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
                {
                    id: 'end_date',
                    label: 'Tanggal Akhir',
                    field: 'end_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
            ],
            tableOptions: {
                baseUrl: '/api/rekapitulasi-pelayanan/kunjungan',
                layout: 'fitDataStretch',
                responsiveLayout: 'collapse',
                columnMinWidth: 80,
                columns: [
                    {
                        title: "No.",
                        field: "no",
                        hozAlign: "center",
                        formatter: "rownum"
                    },
                    {
                        title: "Jenis Kegiatan",
                        field: "poli",
                    },
                    {
                        title: "Kunjungan Pasien Dalam Kab/ Kota",
                        columns: [
                            {
                                title: "Laki-laki",
                                field: "dalam_l",
                                hozAlign: "center",
                            },
                            {
                                title: "Perempuan",
                                field: "dalam_p",
                                hozAlign: "center",
                            }
                        ]
                    },
                    {
                        title: "Kunjungan Pasien Luar Kab/ Kota",
                        columns: [
                            {
                                title: "Laki-laki",
                                field: "luar_l",
                                hozAlign: "center",
                            },
                            {
                                title: "Perempuan",
                                field: "luar_p",
                                hozAlign: "center",
                            }
                        ]
                    },
                    {
                        title: "Total Kunjungan",
                        field: "grand_total",
                        hozAlign: "center",
                    }
                ],
                ajaxResponse: (url, params, response) => response
            }
        }
    },
}
</script>
